import React from "react"
import { retrieveItemImageFromHero } from "../utilities"
import DfbHeadline from "../ui-kit/dfb_headline"
import CEpaperCard from "../elements/c_epaper_card"
import DfbCard from "../elements/dfb_card"
import DfbButton from "../ui-kit/dfb_button"
import Section from "./section"

const MScienceCarousel = (props) => {
  const collection = props.data.collection
  if (!collection) {
    return null
  }

  const moreButtonLink = props.data.link_obj
  const moreButtonText = props.data.link_text

  return (
    <Section
      baseClass="m-ScieneCarousel"
      defaultBgColor={"grey"}
      defaultPadding="extra-large"
      data={props.data}
    >
      <div className="m-ScieneCarousel-wrapper">
        <div className="m-ScieneCarousel-container">
          <div className="c-Headline m-ScieneCarousel-headline">
            <DfbHeadline
              headline={props.data.headline}
              headline_level="h3"
              add_class="c-Headline-strokeLine"
            />
          </div>
          <div
            className="dfb-Slider m-ScieneCarousel-slider"
            data-transition="slide"
            data-indicators
            data-drag
            data-controls
            role="region"
            tabIndex={0}
          >
            <div className="dfb-Slider-slider">
              <ul className="dfb-Slider-slides">
                {collection.map((item) => (
                  <li
                    key={`${props.data.uid}_${item.uid}`}
                    className="dfb-Slider-slideItem"
                  >
                    {item.type === "epaper" && <CEpaperCard data={item} />}
                    {item.type !== "epaper" && <DfbCard data={item} />}
                  </li>
                ))}
              </ul>
              {moreButtonLink && moreButtonLink.url && moreButtonText && (
                <div className="tns-nav">
                  <a href={moreButtonLink.url} className="dfb-Button">
                    <span class="dfb-Button-label">{moreButtonText}</span>
                  </a>
                </div>
              )}
            </div>

            <ul className="dfb-Slider-controls">
              <li className="dfb-Slider-controlElement dfb-Slider-controlElement--previous">
                <DfbButton
                  tagName="button"
                  icon_type="Dropdown Left"
                  add_class="dfb-Slider-control dfb-Slider-control--previous"
                />
              </li>
              <li className="dfb-Slider-controlElement dfb-Slider-controlElement--next">
                <DfbButton
                  tagName="button"
                  icon_type="Dropdown Right"
                  add_class="dfb-Slider-control dfb-Slider-control--next"
                />
              </li>
              {moreButtonLink && moreButtonLink.url && moreButtonText && (
                <li style={{ order: 4 }}>
                  <a href={moreButtonLink.url} className="dfb-Button">
                    <span class="dfb-Button-label">{moreButtonText}</span>
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MScienceCarousel
